import React from 'react'
import ReactApexChart from "react-apexcharts";

function DonutChart({chartOptions}) {
      return (
            <div style={{justifyContent: 'center', display: 'flex'}}>
                  <ReactApexChart
                  options={chartOptions.options}
                  series={chartOptions.series}
                  type={chartOptions.options.chart.type}
                  width={chartOptions.options.chart.width} />
            </div>
      );
   
  }

  export default DonutChart;